<script>
export default {
    methods: {
        cancel() {
            this.cancelled = true;
            this.abortController?.abort();
        },
        reset() {
            this.cancel();
            this.done = false;
            this.cancelled = false;
            this.latencies = [];
            this.averageLatency = 0;
        }
    },
    data() {
        return {
            done: false,
            cancelled: false,
            abortController: null,
            latencies: [],
            averageLatency: 0,
            maximumLatency: 150
        }
    },
    props: ['url', 'enabled'],
    translate25Context: 'troubleshooting',
    computed:
    {
        status() {
            if (!this.done) {
                return 'pending';
            }
            else if (this.averageLatency < this.maximumLatency) {
                return 'ok';
            }
            else {
                return 'ko';
            }
        }
    },
    mounted() {
    },
    watch: {
        enabled: async function () {
            if (this.enabled) {
                this.cancelled = false;
                this.abortController = new AbortController();

                for (let i = 1; i <= 20; i++) {
                    if (this.cancelled) break;

                    const startTime = Date.now(); // Début du téléchargement

                    try {
                        await fetch(this.url, { method: 'HEAD', mode: 'no-cors', signal: this.abortController.signal });
                    } catch (e) {
                        if (e.name === 'AbortError') break;
                    }

                    const endTime = Date.now(); // Fin du téléchargement
                    const duration = endTime - startTime; // Temps en ms

                    this.latencies.push(duration);
                    this.averageLatency = this.latencies.reduce((partialSum, a) => partialSum + a, 0) / i;

                    await new Promise((resolve) =>
                        setTimeout(resolve, 500)
                    );
                }

                if (!this.cancelled) {
                    this.done = true;
                    this.$emit('done');
                }
            }
        },
    }
};
</script>

<template>
    <div class="troubleshooting-bandwith-latency">
        <troubleshooting-page-status :status="status">
            <template #content>
                <div class="troubleshooting-bandwith-latency-title">{{ $vt('Latency') }}
                </div>
            </template>
        </troubleshooting-page-status>
        <div class="troubleshooting-bandwith-latency-value">{{ averageLatency.toFixed(2) }}ms</div>
        <div class="troubleshooting-bandwith-latency-required">{{ $vt('Maximum tolerated is {max}ms', {max: maximumLatency}) }}</div>
    </div>
</template>

<style lang="scss">
.troubleshooting-bandwith-latency {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .troubleshooting-bandwith-latency-title {
        gap: 12px;
        font-family: Lato;
        font-size: 20px;
        font-weight: 700;
        display: flex;
    }

    .troubleshooting-bandwith-latency-value {
        font-family: Lato;
        font-size: 40px;
        font-weight: 700;
    }

    .troubleshooting-bandwith-latency-required
    {
        white-space: nowrap;
    }
}
</style>
